<template>
<!--    <div>Client footer</div>-->
</template>

<script>
export default {
name: "ClientFooter"
}
</script>

<style scoped>

</style>